// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ModalCommon_wrap__34Zyi","header":"ModalCommon_header__2cYoW","title":"ModalCommon_title__2RtUf","bigTitle":"ModalCommon_bigTitle__DcT2o","blur":"ModalCommon_blur__1Oplc"};